import {decorate, inject, injectable} from '@yosmanyga/di';
import {action, observable, runInAction, makeObservable} from 'mobx';
import {NotesApi, NoteType} from '../data';

class NotesController {
    loaded: boolean;
    sending: boolean;
    notes: Array<NoteType>;
    input: string;

    constructor(private noteApi: NotesApi) {
        this.loaded = false;
        this.sending = false;
        this.notes = [];
        this.input = '';
        
        makeObservable(this, {
            loaded: observable,
            sending: observable,
            notes: observable,
            input: observable,
            load: action,
            prepare: action,
            send: action,
            delete: action,
        });
    }

    load = async () => {
        const notes = await this.noteApi.collectNotes();

        runInAction(() => {
            this.notes = notes;
            this.loaded = true;
        });
    };

    prepare = (value: string) => {
        runInAction(() => {
            this.input = value;
        });
    };

    send = async () => {
        runInAction(() => {
            this.sending = true;
        });

        await this.noteApi.addNote(this.input);

        runInAction(() => {
            this.input = '';
            this.sending = false;
        });

        await this.load();
    };

    delete = async (id: string) => {
        await this.noteApi.deleteNote(id);

        await this.load();
    };
}

decorate(injectable(), NotesController);
decorate(inject(NotesApi), NotesController, 0);

export {NotesController};
